import { AsyncStateNotification } from '@ui/notifications';
import { BulkEditModal } from '@ui/modals/bulk/BulkEditModal';
import { BulkEditModalSection } from '@ui/modals/bulk/BulkEditModalSection';
import { ClassificationBulkSelector } from '@ui/tags/ClassificationBulkSelector';
import { createSonarSelector } from '@lib/selectors';
import { difference } from 'lodash';
import { StakeholderSelector } from '@ui/StakeholderSelector';
import { UserSelector } from '@ui/UserSelector';
import { coreActions, StakeholderType } from '@sonar-software/sonar-core';
import { COPY_GENERIC, COPY_SPECIFIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useState } from 'react';
import { useAction } from '@hooks';
const asArray = (ids) => (Array.isArray(ids) ? ids : [ids]);
const bulkPatchSelector = createSonarSelector((state) => state.core.dataSecurity.applications.bulk.patch);
export const AppTableBulkEditModal = ({ popoverTarget, selectableApps, selectionData, typeLabel }) => {
    const [ownerId, setOwnerId] = useState();
    const [stakeholderIds, setStakeholderIds] = useState();
    const [stakeholderGroupId, setStakeholderGroupId] = useState();
    const [classification, setClassification] = useState();
    const bulkPatchApplications = useAction(coreActions.requestPatchCoreDataSecurityApplicationsBulk);
    const reset = () => {
        setOwnerId(undefined);
        setStakeholderIds(undefined);
        setStakeholderGroupId(undefined);
        setClassification(undefined);
        selectionData.resetSelection();
    };
    const disabled = !ownerId &&
        !stakeholderIds &&
        !stakeholderGroupId &&
        !classification;
    const handleOnOk = () => {
        bulkPatchApplications(Object.assign(Object.assign(Object.assign(Object.assign({ applicationIds: selectionData.selectAllEnabled ?
                difference(selectableApps.map((app) => app.applicationId), selectionData.selectedKeys) :
                selectionData.selectedKeys }, classification ? {
            classification: classification === 'null' ? null : classification
        } : {}), ownerId ? { ownerId } : {}), stakeholderGroupId ? { stakeholderGroupId: Number(stakeholderGroupId) } : {}), stakeholderIds ? { stakeholderIds: asArray(stakeholderIds) } : {}));
        reset();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(BulkEditModal, { className: 'app-table-bulk-edit-modal', disabled: disabled, onCancel: reset, onOk: handleOnOk, selectedCount: selectionData.selectedCount, targetNode: popoverTarget, typeLabel: typeLabel },
            React.createElement(BulkEditModalSection, { title: COPY_SPECIFIC.OWNER },
                React.createElement(UserSelector, { allowClear: true, avatar: true, onChange: setOwnerId, placeholder: COPY_SPECIFIC.CHANGE_OWNER, value: ownerId })),
            React.createElement(BulkEditModalSection, { title: COPY_SPECIFIC.STAKEHOLDERS },
                React.createElement(StakeholderSelector, { avatar: true, direction: 'horizontal', mode: 'multiple', onChange: setStakeholderIds, placeholder: COPY_SPECIFIC.ADD_STAKEHOLDERS, value: stakeholderIds })),
            React.createElement(BulkEditModalSection, { title: COPY_SPECIFIC.GROUP },
                React.createElement(StakeholderSelector, { avatar: true, onChange: setStakeholderGroupId, placeholder: COPY_SPECIFIC.ADD_GROUP, stakeholderType: StakeholderType.Team, value: stakeholderGroupId })),
            React.createElement(BulkEditModalSection, { title: COPY_SPECIFIC.CLASSIFICATION },
                React.createElement(ClassificationBulkSelector, { boxless: false, onChange: setClassification, value: classification }))),
        React.createElement(AsyncStateNotification, { errored: COPY_GENERIC.CONTACT_SUPPORT, failed: COPY_GENERIC.CONTACT_SUPPORT, received: NOTIFICATIONS_COPY.SUCCESS_PATCH_APPLICATIONS_BULK, resetRawAction: coreActions.resetPatchCoreDataSecurityApplicationsBulk, stateSelector: bulkPatchSelector })));
};
